import { CS_REVIEW_LIST_SEARCH_KEYWORD_TYPE, CS_REVIEW_LIST_SEARCH_KEYWORD_TYPE_TEXT } from './csReviewConstants';
import { EVENT_LIST_SEARCH_KEYWORD_TYPE, EVENT_LIST_SEARCH_KEYWORD_TYPE_TEXT } from './eventConstants';
import { STORE_LIST_SEARCH_KEYWORD_TYPE, STORE_LIST_SEARCH_KEYWORD_TYPE_TEXT } from './brandConstants';
import {
  PRODUCT_LIST_SEARCH_KEYWORD_TYPE,
  PRODUCT_LIST_SEARCH_KEYWORD_TYPE_TEXT,
  PRODUCT_PROPERTY_KEY,
  PRODUCT_TAG_KEY,
} from './productConstants';

/**
 *  태그 페이지 이름
 */
export const TAG_PAGE_NAME = {
  TAG_CREATE: '태그 등록',
  TAG_DETAIL: '태그 상세',
  TAG_HISTORY: '태그 상세 내역',
  TAG_EDIT: '태그 편집',
  TAG_LIST: '태그 리스트',
  TAG_GROUP_CREATE: '태그 그룹 등록',
  TAG_GROUP_EDIT: '태그 그룹 편집',
  TAG_GROUP_LIST: '태그 그룹 리스트',
  TAG_TAB_MAIN_MANAGEMENT: '태그 탭 메인 관리',
  TAG_TREND_KEYWORD_MANAGEMENT: '태그 트랜드 키워드 관리',
};

/**
 *  태그 상태
 */
export const TAG_STATUS = {
  /**
   *  승인 대기
   */
  confirmReady: 0,
  /**
   *  비활성
   */
  inactive: 1,
  /**
   *  활성
   */
  active: 2,
  /**
   *  삭제
   */
  delete: 3,
};

/**
 *  태그 상태 텍스트
 */
export const TAG_STATUS_TEXT = {
  [TAG_STATUS.confirmReady]: '승인 대기',
  [TAG_STATUS.inactive]: '비활성',
  [TAG_STATUS.active]: '활성',
  [TAG_STATUS.delete]: '삭제',
};

export const TAG_STATUS_V2 = {
  /**
   *  승인 대기
   */
  CONFIRM_READY: 'confirmReady',
  /**
   *  비활성
   */
  INACTIVE: 'inactive',
  /**
   *  활성
   */
  ACTIVE: 'active',
  /**
   *  삭제
   */
  DELETE: 'delete',
} as const;

export const TAG_STATUS_V2_TEXT = {
  [TAG_STATUS_V2.CONFIRM_READY]: '승인 대기',
  [TAG_STATUS_V2.INACTIVE]: '비활성',
  [TAG_STATUS_V2.ACTIVE]: '활성',
  [TAG_STATUS_V2.DELETE]: '삭제',
};

/**
 *  태그 상태 SELECT 리스트
 */
export const TAG_STATUS_SELECT_LIST = [
  {
    id: null,
    name: '전체',
  },
  {
    id: TAG_STATUS.confirmReady,
    name: TAG_STATUS_TEXT[TAG_STATUS.confirmReady],
  },
  {
    id: TAG_STATUS.inactive,
    name: TAG_STATUS_TEXT[TAG_STATUS.inactive],
  },
  {
    id: TAG_STATUS.active,
    name: TAG_STATUS_TEXT[TAG_STATUS.active],
  },
  {
    id: TAG_STATUS.delete,
    name: TAG_STATUS_TEXT[TAG_STATUS.delete],
  },
];

/**
 *  태그 편집 상태 SELECT 리스트
 */
export const TAG_EDIT_STATUS_SELECT_LIST = [
  {
    id: TAG_STATUS.inactive,
    name: TAG_STATUS_TEXT[TAG_STATUS.inactive],
  },
  {
    id: TAG_STATUS.active,
    name: TAG_STATUS_TEXT[TAG_STATUS.active],
  },
];

/**
 *  태그명 최대 글자 수
 */
export const MAXIMUM_NUMBER_OF_TAG_NAME = 13;

/**
 *  태그 그룹명 최대 글자 수
 */
export const MAXIMUM_NUMBER_OF_TAG_GROUP_NAME = 13;

/**
 *  태그에 연관된 아이템 타입
 */
export const TAG_RELATED_ITEM_TYPE = {
  /**
   *  상품
   */
  PRODUCT: 0,
  /**
   *  브랜드
   */
  STORE: 1,
  /**
   *  기획전
   */
  EVENT: 2,
  /**
   *  상품후기
   */
  REVIEW: 3,
};

/**
 *  태그에 연관된 아이템 타입 텍스트
 */
export const TAG_RELATED_ITEM_TYPE_TEXT = {
  [TAG_RELATED_ITEM_TYPE.PRODUCT]: '상품',
  [TAG_RELATED_ITEM_TYPE.STORE]: '브랜드',
  [TAG_RELATED_ITEM_TYPE.EVENT]: '기획전',
  [TAG_RELATED_ITEM_TYPE.REVIEW]: '상품후기',
};

/**
 *  S3 에 저장 될 태그 썸네일 이미지 너비
 */
export const TAG_THUMBNAIL_IMG_WIDTH = 500;

/**
 *  S3 에 저장 될 태그 썸네일 이미지 높이
 */
export const TAG_THUMBNAIL_IMG_HEIGHT = 500;

/**
 *  입력받는 태그 썸네일 이미지 최소 너비
 */
export const MINIMUM_WIDTH_OF_INPUT_TAG_THUMBNAIL_IMG = 300;

/**
 *  입력받는 태그 썸네일 이미지 최소 높이
 */
export const MINIMUM_HEIGHT_OF_INPUT_TAG_THUMBNAIL_IMG = 300;

/**
 *  태그 상세 페이지 패널 name
 */
export const TAG_EDIT_PAGE_PANEL_NAME = {
  /**
   *  태그 상세 정보
   */
  TAG_EDIT_INFO: 'tag-edit-info',
  /**
   *  카테고리
   */
  TAG_EDIT_RELATED_ITEMS: 'tag-edit-related-items',
  /**
   *  태그 트렌드 메인
   */
  TAG_EDIT_TAG_TREND_MAIN: 'tag-edit-tag-trend-main',
};

/**
 *  태그에 연결된 상품 리스트 검색 키워드 타입 SELECT 리스트
 */
export const TAG_DETAIL_RELATED_PRODUCT_LIST_SEARCH_KEYWORD_TYPE_SELECT_LIST = {
  [TAG_RELATED_ITEM_TYPE.PRODUCT]: [
    {
      id: null,
      name: '전체',
    },
    {
      id: PRODUCT_LIST_SEARCH_KEYWORD_TYPE.BRAND_NAME,
      name: PRODUCT_LIST_SEARCH_KEYWORD_TYPE_TEXT[PRODUCT_LIST_SEARCH_KEYWORD_TYPE.BRAND_NAME],
    },
    {
      id: PRODUCT_LIST_SEARCH_KEYWORD_TYPE.BRAND_ID,
      name: PRODUCT_LIST_SEARCH_KEYWORD_TYPE_TEXT[PRODUCT_LIST_SEARCH_KEYWORD_TYPE.BRAND_ID],
    },
    {
      id: PRODUCT_LIST_SEARCH_KEYWORD_TYPE.PRODUCT_NAME,
      name: PRODUCT_LIST_SEARCH_KEYWORD_TYPE_TEXT[PRODUCT_LIST_SEARCH_KEYWORD_TYPE.PRODUCT_NAME],
    },
    {
      id: PRODUCT_LIST_SEARCH_KEYWORD_TYPE.PRODUCT_ID,
      name: PRODUCT_LIST_SEARCH_KEYWORD_TYPE_TEXT[PRODUCT_LIST_SEARCH_KEYWORD_TYPE.PRODUCT_ID],
    },
    {
      id: PRODUCT_LIST_SEARCH_KEYWORD_TYPE.CATEGORY,
      name: PRODUCT_LIST_SEARCH_KEYWORD_TYPE_TEXT[PRODUCT_LIST_SEARCH_KEYWORD_TYPE.CATEGORY],
    },
  ],
  [TAG_RELATED_ITEM_TYPE.STORE]: [
    {
      id: null,
      name: '전체',
    },
    {
      id: STORE_LIST_SEARCH_KEYWORD_TYPE.BRAND_NAME,
      name: STORE_LIST_SEARCH_KEYWORD_TYPE_TEXT[STORE_LIST_SEARCH_KEYWORD_TYPE.BRAND_NAME],
    },
    {
      id: STORE_LIST_SEARCH_KEYWORD_TYPE.BRAND_ID,
      name: STORE_LIST_SEARCH_KEYWORD_TYPE_TEXT[STORE_LIST_SEARCH_KEYWORD_TYPE.BRAND_ID],
    },
  ],
  [TAG_RELATED_ITEM_TYPE.EVENT]: [
    {
      id: null,
      name: '전체',
    },
    {
      id: EVENT_LIST_SEARCH_KEYWORD_TYPE.MAIN_TITLE,
      name: EVENT_LIST_SEARCH_KEYWORD_TYPE_TEXT[EVENT_LIST_SEARCH_KEYWORD_TYPE.MAIN_TITLE],
    },
  ],
  [TAG_RELATED_ITEM_TYPE.REVIEW]: [
    {
      id: null,
      name: '전체',
    },
    {
      id: CS_REVIEW_LIST_SEARCH_KEYWORD_TYPE.PRODUCT_NAME,
      name: CS_REVIEW_LIST_SEARCH_KEYWORD_TYPE_TEXT[CS_REVIEW_LIST_SEARCH_KEYWORD_TYPE.PRODUCT_NAME],
    },
    {
      id: CS_REVIEW_LIST_SEARCH_KEYWORD_TYPE.PRODUCT_ID,
      name: CS_REVIEW_LIST_SEARCH_KEYWORD_TYPE_TEXT[CS_REVIEW_LIST_SEARCH_KEYWORD_TYPE.PRODUCT_ID],
    },
    {
      id: CS_REVIEW_LIST_SEARCH_KEYWORD_TYPE.ORDER_ITEM_ID,
      name: CS_REVIEW_LIST_SEARCH_KEYWORD_TYPE_TEXT[CS_REVIEW_LIST_SEARCH_KEYWORD_TYPE.ORDER_ITEM_ID],
    },
    {
      id: CS_REVIEW_LIST_SEARCH_KEYWORD_TYPE.BUYER_ID,
      name: CS_REVIEW_LIST_SEARCH_KEYWORD_TYPE_TEXT[CS_REVIEW_LIST_SEARCH_KEYWORD_TYPE.BUYER_ID],
    },
    {
      id: CS_REVIEW_LIST_SEARCH_KEYWORD_TYPE.BUYER_NAME,
      name: CS_REVIEW_LIST_SEARCH_KEYWORD_TYPE_TEXT[CS_REVIEW_LIST_SEARCH_KEYWORD_TYPE.BUYER_NAME],
    },
    {
      id: CS_REVIEW_LIST_SEARCH_KEYWORD_TYPE.CONTENT,
      name: CS_REVIEW_LIST_SEARCH_KEYWORD_TYPE_TEXT[CS_REVIEW_LIST_SEARCH_KEYWORD_TYPE.CONTENT],
    },
  ],
};

/**
 *  태그 상세 레이아웃 타입
 */
export const TAG_DETAIL_PAGE_LAYOUT_TYPE = {
  /**
   *  갤러리
   */
  GALLERY: 0,
  /**
   *  피드
   */
  FEED: 1,
};

/**
 *  태그에 연결된 태그의 최소 개수
 */
export const MINIMUM_NUMBER_OF_TAG_RELATION_COUNT = 3;

/**
 *  태그의 대표 컨텐츠 아이템의 개수
 */
export const NUMBER_OF_TAG_TREND_MAIN_ITEM_COUNT = 6;

/**
 *  태그의 조회수, 소식이 최대로 노출이 될 값
 */
export const MAXIMUM_AMOUNT_OF_EXPOSURE_TAG_VIEW_AMOUNT = 99999;

/**
 *  추천 태그 메모 최대 글자 수
 */
export const MAXIMUM_NUMBER_OF_RECOMMEND_TAG_MEMO_TEXT = 1000;

/**
 *  태그 전체 리스트 엑셀 파일 네임
 */
export const TAG_ALL_LIST_EXCEL_FILE_NAME = '전체 태그 리스트';

/**
 *  태그 선택 리스트 엑셀 파일 네임
 */
export const TAG_SELECTED_LIST_EXCEL_FILE_NAME = '선택 태그 리스트';

/**
 *  태그 리스트 엑셀 파일 네임
 */
export const TAG_LIST_EXCEL_FILE_NAME = '태그 리스트';

/**
 *  태그 탭 메인 컨텐츠 타입
 */
export const TAG_TAB_MAIN_CONTENTS_TYPE = {
  /**
   *  상품
   */
  PRODUCT: 0,
  /**
   *  상품후기
   */
  REVIEW: 1,
};

/**
 *  태그에 연관된 아이템 타입 텍스트
 */
export const TAG_TAB_MAIN_CONTENTS_TYPE_TEXT = {
  [TAG_TAB_MAIN_CONTENTS_TYPE.PRODUCT]: '상품',
  [TAG_TAB_MAIN_CONTENTS_TYPE.REVIEW]: '상품후기',
};

/**
 *  태그에 연관된 아이템 타입에서 태그 탭 메인 컨텐츠 타입 변환
 */
export const TAG_RELATED_ITEM_TYPE_TO_TAG_TAB_MAIN_CONTENTS_TYPE = {
  /**
   *  상품
   */
  [TAG_RELATED_ITEM_TYPE.PRODUCT]: TAG_TAB_MAIN_CONTENTS_TYPE.PRODUCT,
  /**
   *  상품후기
   */
  [TAG_RELATED_ITEM_TYPE.REVIEW]: TAG_TAB_MAIN_CONTENTS_TYPE.REVIEW,
};

/**
 *  태그에 연관된 아이템 타입에서 태그 탭 메인 컨텐츠 타입 변환
 */
export const TAG_RELATED_ITEM_TYPE_TO_TAG_TAB_MAIN_CONTENTS_TYPE_SELECT_LIST = [
  {
    id: null,
    name: '전체',
  },
  {
    id: TAG_TAB_MAIN_CONTENTS_TYPE.PRODUCT,
    name: TAG_TAB_MAIN_CONTENTS_TYPE_TEXT[TAG_TAB_MAIN_CONTENTS_TYPE.PRODUCT],
  },
  {
    id: TAG_TAB_MAIN_CONTENTS_TYPE.REVIEW,
    name: TAG_TAB_MAIN_CONTENTS_TYPE_TEXT[TAG_TAB_MAIN_CONTENTS_TYPE.REVIEW],
  },
];

/**
 *  태그 탭 메인 관리 페이지 패널 name
 */
export const TAG_TAB_MAIN_MANAGEMENT_PAGE_PANEL_NAME = {
  /**
   *  태그 트렌트 키워드 리스트
   */
  TAG_TEND_KEYWORD_LIST: 'tag-trend-keyword-list',
  /**
   *  미리 선정된 팔오우한 태그 리스트
   */
  TAG_FOLLOW_SELECTED_LIST: 'tag-follow-selected-list',
};

/**
 *  태그 탭 메인 섹션 타입
 */
export const TAG_TAB_MAIN_SECTION_TYPE = {
  /**
   *  트렌드 키워드 리스트
   */
  TAG_TEND_KEYWORD_LIST: 0,
  /**
   *  미리 선정된 팔로우한 태그 리스트
   */
  TAG_FOLLOW_SELECTED_LIST: 1,
};

/**
 *  태그 탭 메인 섹션 타입 리스트
 */
export const TAG_TAB_MAIN_SECTION_TYPE_LIST = [
  TAG_TAB_MAIN_SECTION_TYPE.TAG_TEND_KEYWORD_LIST,
  TAG_TAB_MAIN_SECTION_TYPE.TAG_FOLLOW_SELECTED_LIST,
];

/**
 *  태그 탭 메인 컨텐츠 아이템의 개수
 */
export const TAG_TAB_MAIN_ITEM_COUNT = {
  /**
   *  트렌드 키워드 리스트
   */
  [TAG_TAB_MAIN_SECTION_TYPE.TAG_TEND_KEYWORD_LIST]: {
    /**
     *  트렌드 키워드 리스트의 최소 개수
     */
    MINIMUM_NUMBER_OF_ITEM_COUNT: 4,
    /**
     *  트렌드 키워드 리스트의 최대 개수
     */
    MAXIMUM_NUMBER_OF_ITEM_COUNT: 10,
  },
  /**
   *  미리 선정된 팔로우한 태그 리스트
   */
  [TAG_TAB_MAIN_SECTION_TYPE.TAG_FOLLOW_SELECTED_LIST]: {
    /**
     *  미리 선정된 팔로우한 태그 리스트의 최소 개수
     */
    MINIMUM_NUMBER_OF_ITEM_COUNT: 10,
    /**
     *  미리 선정된 팔로우한 태그 리스트의 최대 개수
     */
    MAXIMUM_NUMBER_OF_ITEM_COUNT: 30,
  },
};

/**
 *  태그 트렌드 키워드 섹션 타입
 */
export const TAG_TREND_KEYWORD_SECTION_TYPE = {
  /**
   *  top 30 추천 태그 리스트
   */
  RECOMMEND_TAG_TOP_RANK_LIST: 0,
  /**
   *  스타일별 추천 태그 리스트
   */
  RECOMMEND_TAG_STYLE_LIST: 1,
  /**
   *  태그 모아보기 추천 태그 리스트
   */
  RECOMMEND_TAG_COLLECTION_LIST: 2,
};

/**
 *  태그 트렌드 키워드 섹션 타입 리스트
 */
export const TAG_TREND_KEYWORD_SECTION_TYPE_LIST = [
  TAG_TREND_KEYWORD_SECTION_TYPE.RECOMMEND_TAG_TOP_RANK_LIST,
  TAG_TREND_KEYWORD_SECTION_TYPE.RECOMMEND_TAG_STYLE_LIST,
  TAG_TREND_KEYWORD_SECTION_TYPE.RECOMMEND_TAG_COLLECTION_LIST,
];

/**
 *  태그 트렌드 키워드 관리 페이지 패널 name
 */
export const TAG_TREND_KEYWORD_MANAGEMENT_PAGE_PANEL_NAME = {
  /**
   *  top 30 추천 태그 리스트
   */
  [TAG_TREND_KEYWORD_SECTION_TYPE.RECOMMEND_TAG_TOP_RANK_LIST]: 'recommend-tag-top-rank-list',
  /**
   *  스타일별 추천 태그 리스트
   */
  [TAG_TREND_KEYWORD_SECTION_TYPE.RECOMMEND_TAG_STYLE_LIST]: 'recommend-tag-style-list',
  /**
   *  태그 모아보기 추천 태그 리스트
   */
  [TAG_TREND_KEYWORD_SECTION_TYPE.RECOMMEND_TAG_COLLECTION_LIST]: 'recommend-tag-collection-list',
};

/**
 *  태그 트렌드 키워드 컨텐츠 아이템의 개수
 */
export const TAG_TREND_KEYWORD_ITEM_COUNT = {
  /**
   *  top 30 추천 태그 리스트
   */
  [TAG_TREND_KEYWORD_SECTION_TYPE.RECOMMEND_TAG_TOP_RANK_LIST]: {
    /**
     *  top 30 추천 태그 리스트의 최소 개수
     */
    MINIMUM_NUMBER_OF_ITEM_COUNT: 3,
    /**
     *  top 30 추천 태그 리스트의 최대 개수
     */
    MAXIMUM_NUMBER_OF_ITEM_COUNT: 30,
  },
  /**
   *  스타일별 추천 태그 리스트
   */
  [TAG_TREND_KEYWORD_SECTION_TYPE.RECOMMEND_TAG_STYLE_LIST]: {
    /**
     *  스타일별 추천 태그 리스트의 최소 개수
     */
    MINIMUM_NUMBER_OF_ITEM_COUNT: 3,
    /**
     *  스타일별 추천 태그 리스트의 최대 개수
     */
    MAXIMUM_NUMBER_OF_ITEM_COUNT: 30,
  },
  /**
   *  태그 모아보기 추천 태그 리스트
   */
  [TAG_TREND_KEYWORD_SECTION_TYPE.RECOMMEND_TAG_COLLECTION_LIST]: {
    /**
     *  태그 모아보기 추천 태그 리스트의 최소 개수
     */
    MINIMUM_NUMBER_OF_ITEM_COUNT: 3,
  },
};

/**
 *  태그 추천 타입
 */
export const RECOMMEND_TAG_TYPE = {
  /**
   *  태그 탭 - 트렌드 키워드
   */
  TREND_KEYWORD: 0,
  /**
   *  추천 태그 페이지 - top 30
   */
  TOP_RANK: 1,
  /**
   *  추천 태그 페이지 - 스타일별 태그
   */
  STYLE: 2,
  /**
   *  추천 태그 페이지 - 태그 모아보기
   */
  COLLECTION: 3,
  /**
   *  미리 선정된 팔로우된 태그
   */
  TAG_FOLLOW_SELECTED: 4,
  /**
   *  검색 화면 - 추천 태그
   */
  SEARCH_RECOMMEND: 5,
};

/**
 *  태그 추천 타입 텍스트
 */
export const RECOMMEND_TAG_TYPE_TEXT = {
  [RECOMMEND_TAG_TYPE.TREND_KEYWORD]: '태그 탭 - 트렌드 키워드',
  [RECOMMEND_TAG_TYPE.TOP_RANK]: '추천 태그 페이지 - top 30',
  [RECOMMEND_TAG_TYPE.STYLE]: '추천 태그 페이지 - 스타일별 태그',
  [RECOMMEND_TAG_TYPE.COLLECTION]: '추천 태그 페이지 - 태그 모아보기',
  [RECOMMEND_TAG_TYPE.TAG_FOLLOW_SELECTED]: '태그 탭 - 선정된 팔로우된 태그',
  [RECOMMEND_TAG_TYPE.SEARCH_RECOMMEND]: '검색 추천',
};

/**
 *  태그 트렌드 키워드 섹션 타입을 태츠 추천 타입
 */
export const TAG_TREND_KEYWORD_SECTION_TYPE_TO_RECOMMEND_TAG_TYPE = {
  /**
   *  top 30 추천 태그 리스트
   */
  [TAG_TREND_KEYWORD_SECTION_TYPE.RECOMMEND_TAG_TOP_RANK_LIST]: RECOMMEND_TAG_TYPE.TOP_RANK,
  /**
   *  스타일별 추천 태그 리스트
   */
  [TAG_TREND_KEYWORD_SECTION_TYPE.RECOMMEND_TAG_STYLE_LIST]: RECOMMEND_TAG_TYPE.STYLE,
  /**
   *  태그 모아보기 추천 태그 리스트
   */
  [TAG_TREND_KEYWORD_SECTION_TYPE.RECOMMEND_TAG_COLLECTION_LIST]: RECOMMEND_TAG_TYPE.COLLECTION,
};

/**
 *  노출, 승인, 거절 태그 컴포넌트에서 사용될 버튼 타입
 */
export const CONFIRM_TAG_LIST_TYPE = {
  /**
   *  노출중인 태그
   */
  ACTIVE: 0,
  /**
   *  승인대기 태그
   */
  CONFIRM_READY: 1,
  /**
   *  거절된 태그
   */
  REJECT: 2,
};

/**
 *  노출, 승인, 거절 태그 컴포넌트에서 사용될 버튼 타입 텍스트
 */
export const CONFIRM_TAG_LIST_TYPE_TEXT = {
  [CONFIRM_TAG_LIST_TYPE.ACTIVE]: '노출 중인 태그',
  [CONFIRM_TAG_LIST_TYPE.CONFIRM_READY]: '검수 요청 태그',
  [CONFIRM_TAG_LIST_TYPE.REJECT]: '승인 거절된 태그',
};

/**
 *  노출, 승인, 거절 태그 컴포넌트에서 사용될 버튼 타입 리스트
 */
export const CONFIRM_TAG_LIST_TYPE_LIST = [
  CONFIRM_TAG_LIST_TYPE.ACTIVE,
  CONFIRM_TAG_LIST_TYPE.CONFIRM_READY,
  CONFIRM_TAG_LIST_TYPE.REJECT,
];

/**
 *  노출, 승인, 거절 속성 컴포넌트에서 사용될 버튼 타입
 */
export const CONFIRM_PROPERTY_LIST_TYPE = {
  /**
   *  노출중인 속성
   */
  ACTIVE: 'active',
  /**
   *  승인대기 속성
   */
  CONFIRM_READY: 'confirmReady',
  /**
   *  거절된 속성
   */
  REJECT: 'reject',
};

/**
 *  노출, 승인, 거절 태그 컴포넌트에서 사용될 버튼 타입 텍스트
 */
export const CONFIRM_PROPERTY_LIST_TYPE_TEXT = {
  [CONFIRM_PROPERTY_LIST_TYPE.ACTIVE]: '노출 중인 속성',
  [CONFIRM_PROPERTY_LIST_TYPE.CONFIRM_READY]: '검수 요청 속성',
  [CONFIRM_PROPERTY_LIST_TYPE.REJECT]: '승인 거절된 속성',
};

/**
 *  태그 그룹 타입
 */
export const TAG_GROUP_TYPE = {
  /**
   *  일반
   */
  GENERAL: 0,
  /**
   *  상품 카테고리
   */
  PRODUCT_CATEGORY: 1,
  /**
   *  브랜드 카테고리
   */
  BRAND_CATEGORY: 2,
};

/**
 *  태그 그룹 텍스트
 */
export const TAG_GROUP_TYPE_TEXT = {
  /**
   *  일반
   */
  [TAG_GROUP_TYPE.GENERAL]: '일반',
  /**
   *  상품 카테고리
   */
  [TAG_GROUP_TYPE.PRODUCT_CATEGORY]: '상품카테고리',
  /**
   *  브랜드 카테고리
   */
  [TAG_GROUP_TYPE.BRAND_CATEGORY]: '브랜드카테고리',
};

/**
 *  태그 그룹 SELECT LIST
 */
export const TAG_GROUP_TYPE_SELECT_LIST = [
  {
    id: TAG_GROUP_TYPE.GENERAL,
    name: TAG_GROUP_TYPE_TEXT[TAG_GROUP_TYPE.GENERAL],
  },
  {
    id: TAG_GROUP_TYPE.PRODUCT_CATEGORY,
    name: TAG_GROUP_TYPE_TEXT[TAG_GROUP_TYPE.PRODUCT_CATEGORY],
  },
  // {
  //     id: TAG_GROUP_TYPE.BRAND_CATEGORY,
  //     name: TAG_GROUP_TYPE_TEXT[TAG_GROUP_TYPE.BRAND_CATEGORY]
  // },
];

/**
 *  태그 그룹 타입
 */
export const TAG_GROUP_KIND = {
  /**
   *  브랜드 컨셉
   */
  STORE_CONCEPT: 0,
  /**
   *  상품 컨셉
   */
  PRODUCT_CONCEPT: 1,
  /**
   *  컬러/패턴
   */
  COLOR_PATTERN: 2,
  /**
   *  소재/베이스
   */
  MATERIAL_BASE: 3,
  /**
   *  소재/귀걸이침
   */
  MATERIAL_POST_EARRING: 4,
  /**
   *  소재/도금
   */
  MATERIAL_PLATING: 5,
  /**
   *  소재/스톤
   */
  MATERIAL_STONE: 6,
  /**
   *  소재/기타
   */
  MATERIAL_ETC: 7,
  /**
   *  모양
   */
  SHAPE: 8,
  /**
   *  체인 모양
   */
  CHAIN_SHAPE: 9,
  /**
   *  시즌/상황
   */
  SEASON_STATUS: 10,
  /**
   *  컨셉
   */
  CONCEPT: 11,
};

/**
 *  태그 그룹명
 */
export const TAG_GROUP_KIND_NAME = {
  [TAG_GROUP_KIND.STORE_CONCEPT]: '브랜드 컨셉',
  [TAG_GROUP_KIND.PRODUCT_CONCEPT]: '상품 컨셉',
  [TAG_GROUP_KIND.COLOR_PATTERN]: '컬러/패턴',
  [TAG_GROUP_KIND.MATERIAL_BASE]: '소재/베이스',
  [TAG_GROUP_KIND.MATERIAL_POST_EARRING]: '소재/귀걸이침',
  [TAG_GROUP_KIND.MATERIAL_PLATING]: '소재/도금',
  [TAG_GROUP_KIND.MATERIAL_STONE]: '소재/스톤',
  [TAG_GROUP_KIND.MATERIAL_ETC]: '소재/기타',
  [TAG_GROUP_KIND.SHAPE]: '모양',
  [TAG_GROUP_KIND.CHAIN_SHAPE]: '체인 모양',
  [TAG_GROUP_KIND.SEASON_STATUS]: '시즌/상황',
  [TAG_GROUP_KIND.CONCEPT]: '컨셉',
};

/**
 *  기타 소재 태그명
 */
export const MATERIAL_ETC_TAG_NAME = '기타소재';

/**
 *  상품 태그 그룹 타입 리스트
 */
export const PRODUCT_TAG_GROUP_KIND_LIST = [
  /**
   *  컨셉
   */
  TAG_GROUP_KIND.CONCEPT,
  /**
   *  컬러/패턴
   */
  TAG_GROUP_KIND.COLOR_PATTERN,
  /**
   *  소재/베이스
   */
  TAG_GROUP_KIND.MATERIAL_BASE,
  /**
   *  소재/귀걸이침
   */
  TAG_GROUP_KIND.MATERIAL_POST_EARRING,
  /**
   *  소재/도금
   */
  TAG_GROUP_KIND.MATERIAL_PLATING,
  /**
   *  소재/스톤
   */
  TAG_GROUP_KIND.MATERIAL_STONE,
  /**
   *  소재/기타
   */
  TAG_GROUP_KIND.MATERIAL_ETC,
  /**
   *  모양
   */
  TAG_GROUP_KIND.SHAPE,
  /**
   *  체인 모양
   */
  TAG_GROUP_KIND.CHAIN_SHAPE,
  /**
   *  시즌/상황
   */
  TAG_GROUP_KIND.SEASON_STATUS,
];

export const PRODUCT_TAG_AND_PROPERTY_KIND = {
  [PRODUCT_PROPERTY_KEY.MAIN_COLOR]: [TAG_GROUP_KIND.COLOR_PATTERN],
  [PRODUCT_PROPERTY_KEY.MAIN_MATERIAL]: [TAG_GROUP_KIND.MATERIAL_BASE],
  [PRODUCT_PROPERTY_KEY.ACUPUNCTURE_MATERIAL]: [TAG_GROUP_KIND.MATERIAL_POST_EARRING],
  [PRODUCT_PROPERTY_KEY.PLATE_MATERIAL]: [TAG_GROUP_KIND.MATERIAL_PLATING],
  [PRODUCT_PROPERTY_KEY.STONE_MATERIAL]: [TAG_GROUP_KIND.MATERIAL_STONE],
  [PRODUCT_PROPERTY_KEY.OTHER_MATERIAL]: [TAG_GROUP_KIND.MATERIAL_ETC],
  [PRODUCT_PROPERTY_KEY.DECORATIVE_FIGURE]: [TAG_GROUP_KIND.SHAPE],
  [PRODUCT_PROPERTY_KEY.CHAIN_SHAPE]: [TAG_GROUP_KIND.CHAIN_SHAPE],
  [PRODUCT_TAG_KEY.SEASON_SITUATION_TAG]: [TAG_GROUP_KIND.SEASON_STATUS],
  [PRODUCT_TAG_KEY.CONCEPT_TAG]: [TAG_GROUP_KIND.CONCEPT],
};

/**
 *  브랜드 태그 그룹 타입 리스트
 */
export const STORE_TAG_GROUP_KIND_LIST = [
  /**
   *  브랜드 컨셉
   */
  TAG_GROUP_KIND.CONCEPT,
];

/**
 *  태그 로그 타입
 */
export const TAG_LOG_TYPE = {
  /**
   *  태그 팔로우 추가
   */
  FOLLOW: 0,
  /**
   *  태그 팔로우 삭제
   */
  UN_FOLLOW: 1,
  /**
   *  태그 클릭
   */
  CLICK: 3,
};

/**
 *  태그 로그 타입 텍스트
 */
export const TAG_LOG_TYPE_TEXT = {
  /**
   *  태그 팔로우 추가
   */
  [TAG_LOG_TYPE.FOLLOW]: '팔로우 추가',
  /**
   *  태그 팔로우 삭제
   */
  [TAG_LOG_TYPE.UN_FOLLOW]: '팔로우 삭제',
  /**
   *  태그 클릭
   */
  [TAG_LOG_TYPE.CLICK]: '태그 클릭',
};

/**
 *  태그 로그 타입 SELECT LIST
 */
export const TAG_LOG_TYPE_SELECT_LIST = [
  {
    id: TAG_LOG_TYPE.FOLLOW,
    name: TAG_LOG_TYPE_TEXT[TAG_LOG_TYPE.FOLLOW],
  },
  {
    id: TAG_LOG_TYPE.UN_FOLLOW,
    name: TAG_LOG_TYPE_TEXT[TAG_LOG_TYPE.UN_FOLLOW],
  },
  {
    id: TAG_LOG_TYPE.CLICK,
    name: TAG_LOG_TYPE_TEXT[TAG_LOG_TYPE.CLICK],
  },
];

export const TAG_STATUS_V2_TYPE = {
  CONFIRM_READY: 'confirmReady',
  INACTIVE: 'inactive',
  ACTIVE: 'active',
  DELETE: 'delete',
};
